module.exports = __webpack_public_path__ + "static/media/pressure.aeda4ed6.svg";